const BASEURL = "https://emftestbk.athithishala.com/graphql/"; 
export const MEDIAURL = "https://emftestbk.athithishala.com/"; 


// const BASEURL = "https://emfdevbk.athithishala.com/graphql/"; //dev
// export const MEDIAURL = "https://emfdevbk.athithishala.com/"; //dev

// export const MEDIAURL = "https://emfbk.soucient.com/";
// const BASEURL = "https://emfbk.soucient.com/graphql/"; 

export default BASEURL;
